interface ChartPoint {
  label: string
  value: number
}

export function LineChart({ points, suffix = '' }: { points: ChartPoint[]; suffix?: string }) {
  if (points.length < 2) return <div className="empty-chart">Completa dos sesiones para ver la tendencia.</div>
  const width = 340
  const height = 184
  const pad = 18
  const values = points.map((point) => point.value)
  const min = Math.min(...values)
  const max = Math.max(...values)
  const range = Math.max(max - min, 1)
  const coords = points.map((point, index) => ({
    ...point,
    x: pad + index * ((width - pad * 2) / (points.length - 1)),
    y: pad + (max - point.value) * ((height - pad * 2) / range),
  }))
  const path = coords.map((point, index) => `${index ? 'L' : 'M'} ${point.x} ${point.y}`).join(' ')

  return (
    <figure className="line-chart" aria-label={`Tendencia de ${points.length} registros`}>
      <svg viewBox={`0 0 ${width} ${height}`} role="img">
        {[0.25, 0.5, 0.75].map((position) => (
          <line key={position} x1={pad} x2={width - pad} y1={height * position} y2={height * position} className="chart-grid" />
        ))}
        <path d={path} className="chart-line" />
        {coords.map((point, index) => <circle key={`${point.label}-${index}`} cx={point.x} cy={point.y} r={index === coords.length - 1 ? 4.5 : 2.5} className="chart-dot" />)}
      </svg>
      <figcaption>
        <span>{points[0].label}</span>
        <strong>{points.at(-1)?.value.toLocaleString('es-MX', { maximumFractionDigits: 1 })}{suffix}</strong>
        <span>{points.at(-1)?.label}</span>
      </figcaption>
    </figure>
  )
}

